<div class="pa-item-list">
    <div (click)="selectItem(item, message.data.responseItemData.selectionItems)" *ngFor="let item of message.data.responseItemData.selectionItems" [class.disable]="message.data.responseItemData.disableSelectionList"
         [class.inactive]="item.selected === false"
         [ngClass]="item.cssClasses"
         class="pa-list-item">
        <div [style.background-image]="'url(' + item.imageUrl + ')'"
             class="pa-item-image">
        </div>
        <div class="pa-item-content">
            <h2 [title]="item.title">{{item.title}}</h2>
        </div>
    </div>
</div>
